var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineReducers } from "redux";
import { produce } from "immer";
import "./endpoints/index.js";
import { updateStateArray } from "./utils.js";
import { getDefaultAssignmentUnitsReducerState as getDefaultReducerState$1, assignmentUnitsReducer as reducer$1 } from "./endpoints/assignment-units.js";
import { getDefaultGatesReducerState, gatesReducer } from "./endpoints/gates.js";
import { getDefaultGateTypesReducerState, gateTypesReducer } from "./endpoints/gate-types.js";
import { getDefaultProgressionTemplatesReducerState, progressionTemplatesReducer } from "./endpoints/progression-templates.js";
import { getDefaultProgressionsReducerState, progressionsReducer, progressionsMatchers } from "./endpoints/progressions.js";
import { getDefaultExperimentOperationSetsReducerState, experimentOperationSetsReducer } from "./endpoints/experiment-operation-sets.js";
import { getDefaultFeaturesReducerState, featuresReducer, featuresMatchers } from "./endpoints/features.js";
import { getDefaultExperimentsReducerState, experimentsReducer, experimentsMatchers, isExperimenStart, isExperimentStop } from "./endpoints/experiments.js";
import { getDefaultAudienceFiltersReducerState as getDefaultReducerState, audienceFiltersReducer as reducer } from "./endpoints/audience-filters.js";
import { getDefaultIsolationGroupsReducerState as getDefaultReducerState$2, isolationGroupsReducer as reducer$2 } from "./endpoints/isolation-groups.js";
import { getDefaultExperimentationGroupSettingsReducerState, experimentationGroupSettingsReducer } from "./endpoints/experimentation-group-settings.js";
import { getDefaultExperimentationGroupsReducerState, experimentationGroupsReducer } from "./endpoints/experimentation-groups.js";
import { getDefaultVariantsReducerState, variantsReducer } from "./endpoints/variants.js";
const unifiedApiDefaultReducerState = {
  gates: getDefaultGatesReducerState(),
  gateTypes: getDefaultGateTypesReducerState(),
  progressionTemplates: getDefaultProgressionTemplatesReducerState(),
  progressions: getDefaultProgressionsReducerState(),
  experimentOperationSets: getDefaultExperimentOperationSetsReducerState(),
  features: getDefaultFeaturesReducerState(),
  experiments: getDefaultExperimentsReducerState(),
  audienceFilters: getDefaultReducerState(),
  assignmentUnits: getDefaultReducerState$1(),
  isolationGroups: getDefaultReducerState$2(),
  experimentationGroupSettings: getDefaultExperimentationGroupSettingsReducerState(),
  experimentationGroups: getDefaultExperimentationGroupsReducerState(),
  variants: getDefaultVariantsReducerState()
};
const unifiedWorkspaceReducer = combineReducers({
  gates: gatesReducer,
  gateTypes: gateTypesReducer,
  progressionTemplates: progressionTemplatesReducer,
  progressions: progressionsReducer,
  experimentOperationSets: experimentOperationSetsReducer,
  features: featuresReducer,
  experiments: experimentsReducer,
  audienceFilters: reducer,
  assignmentUnits: reducer$1,
  isolationGroups: reducer$2,
  experimentationGroupSettings: experimentationGroupSettingsReducer,
  experimentationGroups: experimentationGroupsReducer,
  variants: variantsReducer
});
const normalizationReducer = (state = unifiedApiDefaultReducerState, action) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
  let draft = __spreadValues({}, state);
  if (featuresMatchers.isCreateUpdateAction(action) || featuresMatchers.isGetAction(action)) {
    for (const experiment of ((_b = (_a = action.outputPayloadAsync) == null ? void 0 : _a.data) == null ? void 0 : _b.experiments) || []) {
      draft = __spreadProps(__spreadValues({}, draft), {
        experiments: __spreadProps(__spreadValues({}, draft.experiments), {
          entityMap: __spreadProps(__spreadValues({}, draft.experiments.entityMap), {
            [experiment.id]: __spreadValues(__spreadValues({}, draft.experiments.entityMap[experiment.id]), experiment)
          })
        })
      });
    }
    for (const progression of ((_d = (_c = action.outputPayloadAsync) == null ? void 0 : _c.data) == null ? void 0 : _d.progressions) || []) {
      draft = __spreadProps(__spreadValues({}, draft), {
        progressions: __spreadProps(__spreadValues({}, draft.progressions), {
          entityMap: __spreadProps(__spreadValues({}, draft.progressions.entityMap), {
            [progression.id]: __spreadValues(__spreadValues({}, draft.progressions.entityMap[progression.id]), progression)
          })
        })
      });
    }
  }
  if (featuresMatchers.isQueryAction(action) && !((_e = action.payload) == null ? void 0 : _e.skipEntityMerge)) {
    for (const feature of ((_g = (_f = action.outputPayloadAsync) == null ? void 0 : _f.data) == null ? void 0 : _g.value) || []) {
      for (const experiment of (feature == null ? void 0 : feature.experiments) || []) {
        draft = __spreadProps(__spreadValues({}, draft), {
          experiments: __spreadProps(__spreadValues({}, draft.experiments), {
            entityMap: __spreadProps(__spreadValues({}, draft.experiments.entityMap), {
              [experiment.id]: __spreadValues(__spreadValues({}, draft.experiments.entityMap[experiment.id]), experiment)
            })
          })
        });
      }
      for (const progression of (feature == null ? void 0 : feature.progressions) || []) {
        draft = __spreadProps(__spreadValues({}, draft), {
          progressions: __spreadProps(__spreadValues({}, draft.progressions), {
            entityMap: __spreadProps(__spreadValues({}, draft.progressions.entityMap), {
              [progression.id]: __spreadValues(__spreadValues({}, draft.progressions.entityMap[progression.id]), progression)
            })
          })
        });
      }
    }
  }
  if (featuresMatchers.isDeleteAction(action) && !((_h = action.outputPayloadAsync) == null ? void 0 : _h.error)) {
    for (const [key, val] of Object.entries(draft.experiments.entityMap)) {
      if ((val == null ? void 0 : val.featureId) === ((_i = action.payload) == null ? void 0 : _i.id)) {
        delete draft.experiments.entityMap[key];
        draft = __spreadProps(__spreadValues({}, draft), {
          experiments: __spreadProps(__spreadValues({}, draft.experiments), {
            entityMap: __spreadValues({}, draft.experiments.entityMap)
          })
        });
      }
    }
    for (const [key, val] of Object.entries(draft.progressions.entityMap)) {
      if ((val == null ? void 0 : val.featureId) === ((_j = action.payload) == null ? void 0 : _j.id)) {
        delete draft.progressions.entityMap[key];
        draft.progressions.entityMap = __spreadValues({}, draft.progressions.entityMap);
      }
    }
  }
  if (experimentsMatchers.isCreateUpdateAction(action) || experimentsMatchers.isGetAction(action) || isExperimenStart(action) || isExperimentStop(action)) {
    const feature = draft.features.entityMap[((_l = (_k = action.outputPayloadAsync) == null ? void 0 : _k.data) == null ? void 0 : _l.featureId) || ""];
    if (!!feature && ((_m = action.outputPayloadAsync) == null ? void 0 : _m.data)) {
      draft = __spreadProps(__spreadValues({}, draft), {
        features: __spreadProps(__spreadValues({}, draft.features), {
          entityMap: __spreadProps(__spreadValues({}, draft.features.entityMap), {
            [feature.id]: __spreadProps(__spreadValues({}, feature), {
              experiments: [...updateStateArray(feature.experiments, (_n = action.outputPayloadAsync) == null ? void 0 : _n.data)]
            })
          })
        })
      });
    }
  }
  if (experimentsMatchers.isQueryAction(action) && !((_o = action.payload) == null ? void 0 : _o.skipEntityMerge)) {
    let experiments = [...((_q = (_p = action.outputPayloadAsync) == null ? void 0 : _p.data) == null ? void 0 : _q.value) || []];
    if (!((_s = (_r = action.payload) == null ? void 0 : _r.query) == null ? void 0 : _s.orderBy)) {
      experiments.reverse();
    }
    for (const experiment of experiments) {
      const feature = draft.features.entityMap[experiment.featureId || ""];
      if (!!feature && ((_t = action.outputPayloadAsync) == null ? void 0 : _t.data)) {
        draft = __spreadProps(__spreadValues({}, draft), {
          features: __spreadProps(__spreadValues({}, draft.features), {
            entityMap: __spreadProps(__spreadValues({}, draft.features.entityMap), {
              [feature.id]: __spreadProps(__spreadValues({}, feature), {
                experiments: [...updateStateArray(feature.experiments, experiment)]
              })
            })
          })
        });
      }
    }
  }
  if (experimentsMatchers.isDeleteAction(action)) {
    for (let feature of Object.values(draft.features.entityMap)) {
      if (!!feature) {
        draft = __spreadProps(__spreadValues({}, draft), {
          features: __spreadProps(__spreadValues({}, draft.features), {
            entityMap: __spreadProps(__spreadValues({}, draft.features.entityMap), {
              [feature.id]: __spreadProps(__spreadValues({}, feature), {
                experiments: [...feature.experiments.filter((exp) => {
                  var _a2;
                  return exp.id !== ((_a2 = action.payload) == null ? void 0 : _a2.id);
                })]
              })
            })
          })
        });
      }
    }
  }
  if (progressionsMatchers.isCreateUpdateAction(action) || progressionsMatchers.isGetAction(action)) {
    const feature = draft.features.entityMap[((_v = (_u = action.outputPayloadAsync) == null ? void 0 : _u.data) == null ? void 0 : _v.featureId) || ""];
    if (!!feature && ((_w = action.outputPayloadAsync) == null ? void 0 : _w.data)) {
      draft = __spreadProps(__spreadValues({}, draft), {
        features: __spreadProps(__spreadValues({}, draft.features), {
          entityMap: __spreadProps(__spreadValues({}, draft.features.entityMap), {
            [feature.id]: __spreadProps(__spreadValues({}, feature), {
              progressions: [...updateStateArray(feature.progressions, (_x = action.outputPayloadAsync) == null ? void 0 : _x.data)]
            })
          })
        })
      });
    }
  }
  if (progressionsMatchers.isDeleteAction(action)) {
    for (let feature of Object.values(draft.features.entityMap)) {
      if (!!feature) {
        draft = __spreadProps(__spreadValues({}, draft), {
          features: __spreadProps(__spreadValues({}, draft.features), {
            entityMap: __spreadProps(__spreadValues({}, draft.features.entityMap), {
              [feature.id]: __spreadProps(__spreadValues({}, feature), {
                progressions: [...feature.progressions.filter((exp) => {
                  var _a2;
                  return exp.id !== ((_a2 = action.payload) == null ? void 0 : _a2.id);
                })]
              })
            })
          })
        });
      }
    }
  }
  return draft;
};
const unifiedRootReducer = (state = {}, action) => {
  var _a;
  if (!((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.workspaceId)) {
    return state;
  }
  return produce(state, (stateDraft) => {
    stateDraft[action.payload.workspaceId] = unifiedWorkspaceReducer(
      stateDraft[action.payload.workspaceId] || unifiedApiDefaultReducerState,
      action
    );
    stateDraft[action.payload.workspaceId] = normalizationReducer(
      stateDraft[action.payload.workspaceId] || unifiedApiDefaultReducerState,
      action
    );
  });
};
export {
  unifiedRootReducer as default,
  unifiedApiDefaultReducerState,
  unifiedRootReducer
};
//# sourceMappingURL=reducers.js.map
